<script lang="ts" setup>
const { t } = useI18n()
</script>

<template>
  <UColorModeImage
    :alt="t('alt')"
    class="select-none opacity-50 dark:opacity-100"
    dark="/images/bases/BaseGlow/glow.svg"
    light="/images/bases/BaseGlow/glow-light.svg"
  />
</template>

<i18n lang="json">
{
  "en": {
    "alt": "A glowing background image to highlight the title"
  },
  "es": {
    "alt": "Una imagen de fondo brillante para resaltar el título"
  },
  "fr": {
    "alt": "Une image de fond lumineuse pour mettre en avant le titre"
  }
}
</i18n>
